var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container",style:({ height: _vm.height })},[_c('download-chart',{attrs:{"feature":"HVAC","noDownload":""},on:{"click":_vm.download}}),_c('canvas',{ref:"chart"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }